"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyReferralCodeExtendedInputs = [
  {
    name: "heading",
    type: "string",
    required: true,
    defaultValue: "Have a referral code?",
  },
  {
    name: "label",
    type: "string",
    required: true,
    defaultValue: "Get [Reward] when making your first online purchase.",
  },
  {
    name: "list",
    type: "list",
    required: true,
    friendlyName: "Steps",
    defaultValue: [
      { value: "Enter the referral code." },
      { value: "Receive [Reward]." },
    ],
    subFields: [
      {
        name: "value",
        type: "string",
        required: true,
      },
    ],
  },
  {
    name: "legalText",
    type: "string",
    required: true,
    defaultValue: "*Purchase must include a Ploom device",
  },
  {
    name: "discountImageDesktop",
    type: "file",
    required: true,
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "discountImageTablet",
    type: "file",
    required: true,
    defaultValue: null,
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "discountImageMobile",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue: null,
  },
  {
    name: "discountHeading",
    type: "string",
    required: true,
    defaultValue: "20%",
  },
  {
    name: "discountLabel",
    type: "string",
    required: true,
    defaultValue: "OFF First order",
  },
  {
    name: "discountSubText",
    type: "string",
    required: true,
    defaultValue: "Apply Referral Code Now!",
  },
  {
    name: "successImageDesktop",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue: null,
  },
  {
    name: "successImageMobile",
    type: "file",
    required: true,
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue: null,
  },
  {
    name: "successHeading",
    type: "string",
    required: true,
    defaultValue: "Referral Code Applied!",
  },
  {
    name: "successLabel",
    type: "string",
    required: true,
    defaultValue:
      "You're all set to receive your reward. Make your first purchase to enjoy [REWARD DESCRIPTION].",
  },
  {
    name: "successBtnLabel",
    type: "string",
    required: true,
    defaultValue: "Shop now",
  },
  {
    name: "successLink",
    type: "string",
    required: true,
    defaultValue: "/en/shop",
  },
  {
    name: "inputLabel",
    type: "string",
    required: true,
    defaultValue: "Referral code",
  },
  {
    name: "inputPlaceholder",
    type: "string",
    required: true,
    defaultValue: "Enter code",
  },
  {
    name: "inputHelperText",
    type: "string",
    required: true,
    defaultValue: "e.g ABCD123",
  },
  {
    name: "btnText",
    type: "string",
    required: true,
    defaultValue: "Apply",
  },
  {
    name: "validationRequiredMessage",
    type: "string",
    required: true,
    defaultValue: "This field is required",
  },
  {
    name: "verifyErrorMessage",
    type: "string",
    required: true,
    defaultValue: "Invalid code. Please try again.",
  },
  {
    name: "isHidden",
    type: "boolean",
    required: true,
    defaultValue: true,
  },
] as const satisfies Inputs;

export const LoyaltyReferralCodeExtendedComponent: RegisteredComponent = {
  name: "MgmAccountDashboard", // Naming it the same as in AEM
  component: dynamic(async () =>
    withValidation(
      loyaltyReferralCodeExtendedInputs,
      (await import("./LoyaltyReferralCodeExtended"))
        .LoyaltyReferralCodeExtended,
      "MgmAccountDashboard"
    )
  ),
  inputs: loyaltyReferralCodeExtendedInputs,
};
